import { type FC, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { Box, Section } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'
import { useAsyncCan } from 'modules/core/lib/useAsyncCan'

import DocumentUploader from 'modules/documents/components/Documents/DocumentUploader'
import ImportErrorsTable, {
  ImportFileValidation,
} from 'modules/job_catalog/components/ImportErrorsTable'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const Component = () => {
  const { value: canCreateJob } = useAsyncCan('job_catalog.create_job')

  return (
    <AuthorizeUser authorizeFn={() => canCreateJob}>
      <ImportJobsErrorPage />
    </AuthorizeUser>
  )
}

interface LocationState {
  validations?: ImportFileValidation[]
}

const ImportJobsErrorPage: FC = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const locationState = useLocation().state as LocationState
  const form = useRef(new Form({ file: null }, { file: 'file' })).current
  const handleDropped = () => {
    const file = form.get('file').value
    navigate(navigation.employees.jobCatalog.list.fullPath(), { state: { file } })
  }

  useUnsafeEffect(() => {
    if (!locationState?.validations) {
      navigate(navigation.employees.jobCatalog.list.fullPath())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationState])

  if (!locationState.validations) return null

  return (
    <ResponsivePage.Body>
      <Box>
        <Section.List
          illustration="alert"
          title={i18n.t('job_catalog.import_errors_page.section_title')}
          description={i18n.t('job_catalog.import_errors_page.section_description')}
        >
          <DocumentUploader
            accept={{
              ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']: ['.xlsx'],
            }}
            field={form.get('file')}
            placeholder={i18n.t('job_catalog.import_jobs_drag_and_drop')}
            onDropped={handleDropped}
          />
        </Section.List>
      </Box>
      <Box paddingX="s64" paddingBottom="s64">
        <ImportErrorsTable errors={locationState.validations} />
      </Box>
    </ResponsivePage.Body>
  )
}

export default Component
